import { APICall } from '../../types';

export enum UserActionTypes {
  RESET_USER = '@@users/RESET_USER',
  REINVITE_USER = '@@users/REINVITE_USER',
  RESET_USER_SUCCESS = '@@users/RESET_USER_SUCCESS',
  REINVITE_USER_SUCCESS = '@@users/REINVITE_USER_SUCCESS',
  RESET_USER_FAILURE = '@@users/RESET_USER_FAILURE',
  REINVITE_USER_FAILURE = '@@users/REINVITE_USER_FAILURE',
}

export interface IUserState {
  apiCallsInProgress: APICall[];
  error?: string;
}
